<template>
  <v-container fluid class="py-0">
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!--Dialog In order to Replace existing fasi with new ciclostd fasi or add as child -->
    <!-- Dialog to show list of fasi standard -->
    <v-dialog v-model="dailogciclostandardconfirm" width="50%">
      <v-overlay :value="overlay" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"
            >Aggiunta / Sostituzione Cicli Standard</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                @click="dailogciclostandardconfirm = false"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="setAsChild" small>Aggiungi</v-btn>
          <v-btn color="warning" @click="setAsCicloNew" small>sostituire</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog to show list of fasi standard -->
    <v-dialog
      v-model="dialogciclistandard"
      width="75%"
      content-class="dialogshadow"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Cicli Standard</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                @click="dialogciclistandard = false"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="height: 60vh; overflow-y: auto">
          <v-data-table :headers="cicloheaders" :items="cicloitems">
            <template v-slot:[`item.edit`]="{ item }">
              <v-col md="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      style="float: left"
                      @click="openconfimationCicloStd(item)"
                      small
                    >
                      <v-icon color="success">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog to show list of fasi standard Table in Ciclo Commessa Produzione -->
    <v-dialog
      v-model="dialogfasestandard"
      width="75%"
      content-class="dialogshadow"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Fasi Standard</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <Button
            colore_icona="success"
            idForm="ARTICOLO_CICLO_PRODUZIONE"
            idOggetto="IMPORT_FASE_STANDARD"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva Fasi Std."
            v-on:buttonClick="showFasi"
          />
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                @click="dialogfasestandard = false"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-data-table
            v-model="selected"
            item-key="des_fase_standard"
            :headers="fasiHeaders"
            :items="fasiStdLista"
            :single-select="singleSelect"
            show-select
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_agg_operazione" content-class="dialogshadow">
      <AggiungiOperazione @click_indietro="dialog_agg_operazione = false" />
    </v-dialog>

    <!-- Dialog to show list of fasi standard -->
    <v-dialog
      v-model="dialogfasestandard1"
      width="75%"
      content-class="dialogshadow"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Fasi Standard</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                @click="dialogfasestandard1 = false"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-data-table :headers="fasiHeaders" :items="fasiStdLista">
            <template v-slot:[`item.edit`]="{ item }">
              <v-col md="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      style="float: left"
                      @click="addToCicli(item)"
                      small
                    >
                      <v-icon color="primary">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Confirmation Dialog Before saving the Articolo ciclo -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogSavingConfirmation"
      width="400"
    >
      <v-card>
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">Salvataggio</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro di voler salvare il ciclo?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" dark @click="dialogSavingConfirmation = false">
            ANNULLA
          </v-btn>
          <v-btn color="success" dark @click="UpdateCicloFasi">CONFERMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Confirmation Dialog before Deletion of Articolo ciclo -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogdeletecicloconfirmation"
      width="400"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text"> Cancellazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Sei sicuro di di voler eliminare questo elemento?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" dark @click="delSelectedItem">ANNULLA</v-btn>
          <v-btn color="success" dark @click="delCiclo">CONFERMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Ciclo Dialog In order to Add/Remove Ciclo -->
    <v-dialog
      v-model="dialogCiclo"
      persistent
      :scrollable="false"
      content-class="dialogshadow"
    >
      <!-- width="1450" -->
      <form>
        <v-card>
          <v-toolbar class="indigo darken-1" dense>
            <v-toolbar-title class="white--text">
              Ciclo Produzione
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    getFaseStd();
                    dialogfasestandard1 = true;
                  "
                  v-on="on"
                  v-bind="attrs"
                  class="mr-5"
                  small
                >
                  <v-icon color="primary"> mdi-shape-circle-plus </v-icon>
                </v-btn>
              </template>
              <span> Aggiungi fase standard</span>
            </v-tooltip>
            <Button
              bottone_class="ml-auto mr-3"
              colore_icona="success"
              idForm="ARTICOLO_CICLO_PRODUZIONE"
              idOggetto="SALVA_ARTICOLO_FASE"
              mdi_icona="mdi-floppy"
              testo_tooltip="Salva Fase"
              v-on:buttonClick="checkcodfase"
            />
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="closeDialog" v-on="on" v-bind="attrs" small>
                  <v-icon color="error">mdi-window-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text class="py-0" style="max-height: 600px; overflow-y: auto">
            <v-container fluid>
              <v-row align="center" class="my-0" justify="center">
                <v-col cols="2">
                  <v-text-field
                    dense
                    hide-details
                    label="Cod. Fase"
                    palceholder_input="Cod. Fase"
                    v-model="cod_fase"
                    :min="0"
                    type="number"
                  />
                </v-col>
                <v-col cols="2">
                  <v-autocomplete
                    dense
                    hide-details
                    v-model="des1"
                    :items="produzione_list"
                    label="Tipo Produzione"
                    placeholder="Tipo Produzione"
                    item-text="des"
                    item-value="des"
                    required
                  >
                    <template #label>
                      <span class="">Tipo Produzione<strong>* </strong></span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-switch
                    dense
                    hide-details
                    v-model="materia_prima"
                    label="Prelievo Comp."
                    style="margin-top: -0.3rem !important"
                    class="mt-n1 ml-10"
                    :false-value="0"
                    :true-value="1"
                  ></v-switch>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    dense
                    hide-details
                    label="Tempo Standard"
                    v-model="tempo_standard"
                    :min="0"
                    type="number"
                  />
                </v-col>
                <v-col cols="2">
                  <v-autocomplete
                    dense
                    hide-details
                    v-model="um_tempo"
                    :items="unita_misura_lead_time"
                    label="UM Tempo"
                    :placeholder="this.um_tempo ? this.um_tempo : 'UM Tempo'"
                    item-text="des"
                    required
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    dense
                    hide-details
                    label="Peso / Q.tà Dettaglio"
                    v-model="peso"
                    :min="0"
                    type="number"
                  />
                </v-col>
              </v-row>
              <v-row align="center" class="my-0" justify="start">
                <v-col cols="2">
                  <v-autocomplete
                    dense
                    hide-details
                    v-model="um_pezzo"
                    :items="unita_misura_peso"
                    label="UM Peso"
                    item-text="des"
                    required
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-autocomplete
                    dense
                    hide-details
                    v-model="des"
                    :items="fase_lavorazione_list"
                    label="Fase. Lavo"
                    placeholder="Fase. Lavo"
                    item-text="des"
                    required
                  >
                    <!-- :rules="[(value) => value !==  '']"-->
                    <template #label>
                      <span>Fase. Lavo<strong>* </strong></span>
                      <a @click.stop style="pointer-events: all">
                        <Modules
                          v-on:dialogModules="aggiornaFase"
                          tipo="FASE"
                          nome="Fase"
                          setaction="settabelle"
                          getaction="gettabelle"
                          controller="Magazzino"
                          filter="validita = 1"
                          :dati="[{ des: '' }]"
                        />
                      </a>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-switch
                    dense
                    hide-details
                    label="Fase Esterna"
                    v-model="fase_esterna"
                    style="margin-top: -0.3rem !important"
                    class="mt-n1 ml-10"
                    :false-value="0"
                    :true-value="1"
                  ></v-switch>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    dense
                    hide-details
                    label="PZ. Parall."
                    :min="0"
                    type="number"
                    v-model="pezzi_parallelismo"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    dense
                    hide-details
                    label="Perc. Parall."
                    :max="100"
                    :min="0"
                    type="number"
                    v-model="percentuale_parallelismo"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    dense
                    hide-details
                    label="Pezzi Setup"
                    type="number"
                    v-model="pezzi_setup"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row align="center" class="my-0" justify="start">
                <v-col cols="2">
                  <v-icon
                    :color="
                      flag_segnalazione == null ||
                      flag_segnalazione == '' ||
                      flag_segnalazione == 0
                        ? ''
                        : 'success'
                    "
                    @click="switchFlagSegnalazione()"
                  >
                    {{
                      flag_segnalazione == null ||
                      flag_segnalazione == "" ||
                      flag_segnalazione == 0
                        ? "mdi-checkbox-blank-outline"
                        : "mdi-checkbox-marked"
                    }}
                  </v-icon>
                  Genera Segnalazione
                </v-col>
                <v-col cols="2">
                  <v-icon
                    :color="
                      multioperatore == null ||
                      multioperatore == '' ||
                      multioperatore == 0
                        ? ''
                        : 'success'
                    "
                    @click="switchFlagMultioperatore()"
                  >
                    {{
                      multioperatore == null ||
                      multioperatore == "" ||
                      multioperatore == 0
                        ? "mdi-checkbox-blank-outline"
                        : "mdi-checkbox-marked"
                    }}
                  </v-icon>
                  Multioperatore
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    dense
                    hide-details
                    label="Lead Time"
                    type="number"
                    v-model.number="lead_time"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="mt-n7" v-show="fase_esterna == 1">
                  <Fornitura
                    FORM_ID="ARTICOLO"
                    ref="Fornitoridetails"
                    SOTTO_FORM="ARTICOLO_CICLO_PRODUZIONE"
                    :FORM_BUTTON_ARRAY="FORM_BUTTON_ARRAY"
                    v-on:updateFornitura="updateFornitura($event)"
                    :ID_ARTICOLO="ID_ARTICOLO"
                    :ID_CICLO_FASI="ID_CICLO_FASI"
                    :is_selezione_multipla="is_selezione_multipla"
                    :key="ID_CICLO_FASI"
                    :data="this.fornitoriLista"
                    v-on:delFornitura="delFornitura($event)"
                  />
                </v-col>
                <v-col cols="6" v-show="fase_esterna == 0">
                  <Macchina
                    FORM_ID="ARTICOLO"
                    SOTTO_FORM="ARTICOLO_CICLO_PRODUZIONE"
                    ref="Macchinedetails"
                    :MACCHINA_BUTTON_ARRAY="MACCHINA_BUTTON_ARRAY"
                    :ID_ARTICOLO="ID_ARTICOLO"
                    :ID_CICLO_FASI="ID_CICLO_FASI"
                    :is_selezione_multipla="is_selezione_multipla"
                    :key="ID_CICLO_FASI"
                    v-on:delMacchina="delMacchina($event)"
                    :data="this.articolo_ciclo_fasi_macchina"
                    v-on:updateMacchina="updateMacchina($event)"
                  />
                </v-col>
                <v-col cols="6" v-show="fase_esterna == 0">
                  <Personale
                    FORM_ID="ARTICOLO"
                    SOTTO_FORM="ARTICOLO_CICLO_PRODUZIONE"
                    ref="Personaledetails"
                    :PERSONALE_BUTTON_ARRAY="PERSONALE_BUTTON_ARRAY"
                    :ID_ARTICOLO="ID_ARTICOLO"
                    :ID_CICLO_FASI="ID_CICLO_FASI"
                    :is_selezione_multipla="is_selezione_multipla"
                    :key="ID_CICLO_FASI"
                    v-on:delPersonale="delPersonale($event)"
                    :data="this.articolo_ciclo_fasi_personale"
                    v-on:updatePersonale="updatePersonale($event)"
                  />
                </v-col>
              </v-row>
              <v-row align="center" justify="start">
                <v-col md="6">
                  <v-textarea
                    outlined
                    v-model="note"
                    item-text="text"
                    label="Annotazione"
                    placeholder="Annotazione"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
    <!-- Main Table of Fase Standard -->
    <v-row>
      <v-col md="12">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Cicli Produzione
            </v-toolbar-title>
            <v-text-field
              style="background-color: white !important"
              class="ml-2"
              v-model="search"
              label="Cerca"
              single-line
              hide-details
            >
              <v-icon slot="append" color="primary"> mdi-magnify </v-icon>
            </v-text-field>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="salvaCicloMultiplo"
                  small
                  v-if="toolbar_save_btn === true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <Button
              classe_bottone="mr-5"
              colore_icona="primary"
              idForm="ARTICOLO_CICLO_PRODUZIONE"
              idOggetto="CREA_ARTICOLO_FASE"
              mdi_icona="mdi-plus"
              testo_tooltip="Nuova Fase"
              v-on:buttonClick="opendialogciclo"
            />
            <Button
              classe_bottone="mr-5"
              colore_icona="primary"
              idForm="ARTICOLO_CICLO_PRODUZIONE"
              idOggetto="AGGIUNGI_CICLO_STANDARD"
              mdi_icona="  mdi-vector-circle-variant"
              testo_tooltip="Aggiungi ciclo standard"
              v-on:buttonClick="
                getCicloStd();
                dialogciclistandard = true;
              "
            />
            <Button
              classe_bottone="mr-5"
              colore_icona="primary"
              idForm="ARTICOLO_CICLO_PRODUZIONE"
              idOggetto="AGGIUNGI_FASE_STANDARD"
              mdi_icona="mdi-shape-circle-plus"
              testo_tooltip="Aggiungi fase standard"
              v-on:buttonClick="
                dialogfasestandard = true;
                getFaseStd();
              "
            />
            <!-- <Button
              classe_bottone="mr-5"
              colore_icona="purple"
              idForm="ARTICOLO_CICLO_PRODUZIONE"
              idOggetto="AGGIUNGI_OPERAZIONE"
              mdi_icona="mdi-shape-circle-plus"
              testo_tooltip="Aggiungi opearazione"
              v-on:buttonClick="
                dialog_agg_operazione = true;
              "
            /> -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="dialog_agg_operazione = true"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="purple"> mdi-shape-circle-plus </v-icon>
                </v-btn>
              </template>
              <span>Aggiungi Operazione</span>
            </v-tooltip>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :loading="loadingCiclo"
              :headers="CicloHeaders"
              :items="cicloLista"
              :search="search"
            >
              <v-progress-linear
                v-show="progressBarCiclo"
                slot="progress"
                color="blue"
                indeterminate
              ></v-progress-linear>
              <template v-slot:[`item.edit`]="{ item }">
                <Button
                  style="float: left"
                  colore_icona="primary"
                  idForm="ARTICOLO_CICLO_PRODUZIONE"
                  idOggetto="MODIFICA_ARTICOLO_FASE"
                  mdi_icona="mdi-pencil"
                  testo_tooltip="Modifica"
                  v-on:buttonClick="
                    handleClick(item);
                    ID_ARTICOLO = item.id_articolo;
                    ID_CICLO_FASI = item.id_ciclo_fasi;
                  "
                />
              </template>
              <template v-slot:[`item.allegati`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      style="float: left"
                      @click="clickAllegati(item)"
                      small
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon color="primary">mdi-paperclip</v-icon>
                    </v-btn>
                  </template>
                  <span>Allegati</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.quickcheck`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickQuestionari(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-help-network</v-icon>
                    </v-btn>
                  </template>
                  <span>Questionari</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.flag_segnalazione`]="{ item }">
                <v-icon
                  :color="
                    item.flag_segnalazione == null ||
                    item.flag_segnalazione == '' ||
                    item.flag_segnalazione == 0
                      ? ''
                      : 'success'
                  "
                >
                  {{
                    item.flag_segnalazione == null ||
                    item.flag_segnalazione == "" ||
                    item.flag_segnalazione == 0
                      ? "mdi-checkbox-blank-outline"
                      : "mdi-checkbox-marked"
                  }}
                </v-icon>
              </template>
              <template v-slot:[`item.multioperatore`]="{ item }">
                <v-icon
                  :color="
                    item.multioperatore == null ||
                    item.multioperatore == '' ||
                    item.multioperatore == 0
                      ? ''
                      : 'success'
                  "
                >
                  {{
                    item.multioperatore == null ||
                    item.multioperatore == "" ||
                    item.multioperatore == 0
                      ? "mdi-checkbox-blank-outline"
                      : "mdi-checkbox-marked"
                  }}
                </v-icon>
              </template>
              <template v-slot:[`item.operazioni`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickOperazioni(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-database</v-icon>
                    </v-btn>
                  </template>
                  <span>Operazioni</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.materia_prima`]="{ item }">
                <v-icon v-if="item.materia_prima === 1"
                  >mdi-check-underline</v-icon
                >
              </template>
              <template v-slot:[`item.fase_esterna`]="{ item }">
                <v-icon v-if="item.fase_esterna === 1"
                  >mdi-check-underline</v-icon
                >
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <Button
                  colore_icona="error"
                  idForm="ARTICOLO_CICLO_PRODUZIONE"
                  idOggetto="ELIMINA_ARTICOLO_FASE"
                  mdi_icona="mdi-window-close"
                  testo_tooltip="Cancellare"
                  v-on:buttonClick="seletedCiclo(item)"
                />
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Allegati Attachments -->
    <v-dialog id="dialog_allegati" persistent v-model="allegati_dialog_visible">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Documenti di Controllo
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <Button
            colore_icona="success"
            idForm="ARTICOLO_CICLO_PRODUZIONE"
            idOggetto="SALVA_FASE_ALLEGATI"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva Allegati"
            v-on:buttonClick="salvaAllegati"
          />
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogAllegati"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <GestioneAllegato
            controller_allegati="Global"
            controller_caratteristiche_tabella="Manutenzione"
            :id_riferimento="id_fase_sel"
            ref="componenteAllegati"
            :show_close="false"
            @snackbarOpen="snackbarOpen"
            tipo_allegato="CONTROLLO"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog dei questionari associati alla fase -->
    <v-dialog v-model="questionari_fase_visible">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Questionari Associati
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di aggiunta -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="aggiungiQestionario"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaQuestionariAssociati"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="questionari_fase_visible = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-data-table
            :headers="headers_questionari_associati"
            :items="items_questionari_associati.filter((q) => q.validita == 1)"
          >
            <!-- Bottone di eliminazione -->
            <template v-slot:[`item.eliminazione`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickEliminaQuestionarioAllegato(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Elimina</span>
              </v-tooltip>
            </template>

            <!-- Autocomplete del pulsante -->
            <template v-slot:[`item.pulsante`]="{ item }">
              <v-autocomplete
                dense
                hide-details
                item-text="text"
                item-value="value"
                :items="items_pulsanti_questionari"
                style="max-width: 200px"
                v-model="item.pulsante"
              >
              </v-autocomplete>
            </template>

            <!-- Autocomplete dell'obbligatorietà -->
            <template v-slot:[`item.obbligatorio`]="{ item }">
              <v-icon
                @click="switchObblogatorieta(item)"
                :color="
                  (item.obbligatorio == 0) == null ||
                  item.obbligatorio == 0 ||
                  item.obbligatorio == ''
                    ? ''
                    : 'primary'
                "
              >
                {{
                  (item.obbligatorio == 0) == null ||
                  item.obbligatorio == 0 ||
                  item.obbligatorio == ""
                    ? "mdi-checkbox-blank-outline"
                    : "mdi-checkbox-marked"
                }}
              </v-icon>
            </template>

            <!-- Colonna del multiplo -->
            <template v-slot:[`item.multiplo`]="{ item }">
              <v-icon
                @click="switchMultiplo(item)"
                :color="
                  item.multiplo == 0 ||
                  item.multiplo == 0 ||
                  item.multiplo == ''
                    ? ''
                    : 'primary'
                "
              >
                {{
                  item.multiplo == 0 ||
                  item.multiplo == 0 ||
                  item.multiplo == ""
                    ? "mdi-checkbox-blank-outline"
                    : "mdi-checkbox-marked"
                }}
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog del componente dinamico Check -->
    <v-dialog class="ma-0 pa-0" v-model="check_dialog_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeCheck"
            :component="'check'"
            ref="windowframe_check"
            @questionario_selezionato="handleQuestionarioSelezionato"
            @loaded="handleCheckLoaded"
            :input_args="input_args"
          />
          <!-- :input_args="{tipo:33320}"-->
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei questionari associati -->
    <v-dialog v-model="conferma_eliminazione_questionario" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare l'associazione del questionario
            selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_eliminazione_questionario = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaQuestionarioAllegato" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog delle operazioni -->
    <v-dialog v-model="dialog_operazioni" width="unset">
      <TabellaOperazioni
        @click_indietro="dialog_operazioni = false"
        :riferimento="id_fase_sel"
        :tipo_riferimento="'id_ciclo_fasi'"
        :visible="dialog_operazioni"
      />
    </v-dialog>

    <!-- In order to show All the Alerts -->
    <v-snackbar
      content-class="snackbar"
      :color="color"
      right
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :size="64">{{ mainIcon }}</v-icon>
      <h2 class="ml-16">{{ snackbar_text }}</h2>
      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
        color="white"
      >
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-container>
</template>
<script>
import _ from "lodash";
import Button from "@/components/TOOLS/FormComponentPermissions/Button.vue";
// import TextField from "@/components/TOOLS/FormComponentPermissions/TextField.vue";
import Fornitura from "../../Common/Fornitura.vue";
import Macchina from "../../Common/Macchina.vue";
import moment from "moment/moment";
import Personale from "../../Common/Personale.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TabellaOperazioni from "@/components/OPERAZIONI/TabellaOperazioni.vue";
import AggiungiOperazione from "@/components/OPERAZIONI/AggiungiOperazione.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    id_articoli_sel: {
      type: Array,
      default: () => [],
    },
    is_selezione_multipla: {
      type: Boolean,
      default: false,
    },
    toolbar_save_btn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Button,
    // TextField,
    Modules: () => import("../../../../components/TOOLS/Modules"),
    GestioneAllegato: () => import("@/components/TOOLS/GestioneAllegato.vue"),
    AggiungiOperazione,
    Fornitura,
    Macchina,
    Personale,
    SnackbarQV,
    TabellaOperazioni,
    WindowFrame,
  },
  data() {
    return {
      // Part Program
      associatePartPrgoram: null,
      rules: {},
      FORM_BUTTON_ARRAY: [
        "CREA_ARTICOLO_FASE_FORNITURA",
        "MODIFICA_ARTICOLO_FASE_FORNITURA",
        "ELIMINA_ARTICOLO_FASE_FORNITURA",
        "SALVA_ARTICOLO_FASE_FORNITURA",
      ],
      MACCHINA_BUTTON_ARRAY: [
        "CREA_ARTICOLO_FASE_MACCHINA",
        "MODIFICA_ARTICOLO_FASE_MACCHINA",
        "ELIMINA_ARTICOLO_FASE_MACCHINA",
        "SALVA_ARTICOLO_FASE_MACCHINA",
      ],
      PERSONALE_BUTTON_ARRAY: [
        "CREA_ARTICOLO_FASE_PERSONALE",
        "MODIFICA_ARTICOLO_FASE_PERSONALE",
        "ELIMINA_ARTICOLO_FASE_PERSONALE",
        "SALVA_ARTICOLO_FASE_PERSONALE",
      ],
      // Variables for Allegati
      allegati_dialog_visible: false,
      //<==============================Ciclo Variables=====================>//
      id_fase_sel: null,
      dialog_operazioni: false,
      fase_description: "",
      cicloLista: [],
      fase_lavorazione_list: [],
      items_pulsanti_questionari: new Array(),
      dialogCiclo: false,
      id_ciclo_fasi: "",
      cod_fase: "",
      percentuale_parallelismo: 0,
      pezzi_setup: 0,
      pezzi_parallelismo: 0,
      produzione_list: [],
      id_tipo_fase: "",
      id_fase: "",
      fase_list: [],
      search: "",
      peso: "",
      unita_misura_peso: [],
      des: "",
      des1: "",
      cod_macchina: null,
      costo_lavorazione: null,
      fase_esterna: 0,
      materia_prima: 0,
      tempo_standard: 0,
      id_um_tempo: "",
      des_um_tempo: "",
      id_um_pezzo: "",
      um_pezzo: "",
      singleitem: {},
      note: "",
      loadingCiclo: false,
      progressBarCiclo: false,
      // Variable for pop modal for deletion
      dialogdeletecicloconfirmation: false,
      selectedCiclo: {},
      //<======== Fornitura Variables =====>//
      ID_ARTICOLO: -1,
      ID_CICLO_FASI: -1,
      fornitoriLista: [],
      deletedFornitura: [],
      // Macchina Variables
      um_tempo: [],
      unita_misura_lead_time: [],
      articolo_ciclo_fasi_macchina: [],
      singleMacchina: {},
      deletedMacchina: [],
      macchinaList: [],
      idciclo_fasi_macchina: -1,
      // Personale Variables
      articolo_ciclo_fasi_personale: [],
      idciclo_fasi_personale: "",
      deletedPersonale: [],
      // Variabili d'appoggio
      index_sel: null,
      //  <=======================Generic Variables =====================>
      // cicloheaders
      cicloheaders: [],
      cicloitems: [],
      landing_page_check: "dashboard",
      input_args: {
        toolbar_visible: localStorage.id_profilo == 1 ? true : false,
        toolbar_btn_autorizzazioni: true,
        toolbar_btn_chiudi: localStorage.id_profilo == 1 ? true : false,
        toolbar_btn_esecuzione: false,
        toolbar_btn_progettazione: true,
        toolbar_btn_risultati: false,
      },
      headers_questionari_associati: [
        {
          text: "Titolo",
          value: "titolo_questionario",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des_questionario",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "des_tipo",
          sortable: false,
        },
        {
          text: "Pulsante",
          value: "pulsante",
          sortable: false,
          width: "200px",
        },
        {
          text: "Obbligatorio",
          value: "obbligatorio",
          sortable: false,
          width: "100px",
        },
        {
          text: "Completamento Multiplo",
          value: "multiplo",
          sortable: false,
          width: "100px",
        },
        {
          text: "Eliminazione",
          value: "eliminazione",
          sortable: false,
          width: "150px",
        },
      ],
      items_questionari_associati: new Array(),
      // Dialog Ciclo Standard
      dialogciclistandard: false,
      flag_segnalazione: false,
      lead_time: null,
      multioperatore: false,
      conferma_eliminazione_questionario: false,
      id_questionario_sel: null,
      // Dailog Ciclo Standard Confirmation
      dailogciclostandardconfirm: false,
      selectedCicloStd: {},
      // Dailog Fase Standard
      singleSelect: false,
      selected: [],
      dialogfasestandard1: false,
      dialogfasestandard: false,
      dialog_agg_operazione: false,
      item: "",
      overlay: false,
      id_articolo: this.data.id_articolo,
      validita: 1,
      // Confirmation Dialog
      dialogSavingConfirmation: false,
      check_dialog_visible: false,
      questionari_fase_visible: false,
      // Snackbar Variables
      color: "",
      snackbar: false,
      mainIcon: "",
      snackbar_icon: "",
      snackbar_text: "",
      // Fasi Standard List and Fasi standard Headers
      fasiStdLista: [],
      fasiHeaders: [],
      last_item: null,
      // Header of ciclo table
      CicloHeaders: [
        {
          value: "edit",
        },
        {
          value: "allegati",
          sortable: false,
        },
        {
          text: "Questionari",
          value: "quickcheck",
          sortable: false,
        },
        {
          text: "Genera Segnalazione",
          value: "flag_segnalazione",
          sortable: false,
        },
        {
          text: "Multioperatore",
          value: "multioperatore",
          sortable: false,
        },
        /*{
          text: "Operazioni",
          value: "operazioni",
          sortable: false,
        },*/
        {
          text: "Cod. Fase",
          value: "cod_fase",
          sortable: false,
        },
        {
          text: "Tipo Fase",
          value: "des1",
          sortable: false,
        },
        {
          text: "Prelievo Comp",
          value: "materia_prima",
          sortable: false,
        },
        {
          text: "Lavoro Esterna",
          value: "fase_esterna",
          sortable: false,
        },
        {
          text: "Fase Lavoro",
          value: "des",
          sortable: false,
        },
        {
          text: "Peso / Q.tà Dettaglio",
          value: "peso",
          sortable: false,
        },
        {
          text: "Lotto Prod",
          value: "lotto_produzione",
          sortable: false,
        },
        {
          text: "Ragione Sociale",
          value: "ragione_sociale",
          sortable: false,
        },
        {
          text: "Trasf. Diretto",
          value: "trasf_diretto",
          sortable: false,
        },
        {
          text: "Lead Time",
          value: "lead_time",
          sortable: false,
        },
        {
          text: "Lotto Lavoro",
          value: "lotto_lavorazione",
          sortable: false,
        },
        {
          text: "Costo Lavoro",
          value: "costo_lavorazione",
          sortable: false,
        },
        {
          text: "Tempo Standard",
          value: "tempo_standard",
          sortable: false,
        },
        {
          text: "Pezzi/h Min",
          value: "pezzi_ora_min",
          sortable: false,
        },
        {
          text: "Pezzi/h Max",
          value: "pezzi_ora_max",
          sortable: false,
        },
        {
          text: "Macchina",
          value: "codice",
          sortable: false,
        },
        {
          text: "Tempo Setup",
          value: "tempo_setup",
          sortable: false,
        },
        {
          text: "Attrezzatura",
          value: "id_attrezzatura",
          sortable: false,
        },
        {
          text: "Perc. Parall.",
          value: "percentuale_parallelismo",
          sortable: false,
        },
        {
          text: "Pz. Parall.",
          value: "pezzi_parallelismo",
          sortable: false,
        },
        {
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    aggiungiQestionario() {
      this.check_dialog_visible = true;
    },
    closeCheck() {
      this.check_dialog_visible = false;
    },
    getRelazioniModuli() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          id_riferimento: this.id_fase_sel,
          id_personale: localStorage.id,
          riferimento: "articolo_ciclo_fasi",
          modulo: "questionario",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_questionari_associati = new Array();
            this.items_questionari_associati = Array.from(
              res.data.result.tabella
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        landing_page: this.landing_page_check,
      });
    },
    clickOperazioni(arg) {
      this.id_fase_sel = arg.id_ciclo_fasi;
      this.dialog_operazioni = true;
    },
    async clickQuestionari(arg) {
      this.id_fase_sel = arg.id_ciclo_fasi;
      const getrelazioni = await this.getRelazioniModuli();
      if (getrelazioni === true) {
        this.questionari_fase_visible = true;
      }
    },
    delPersonale(ev) {
      this.deletedPersonale = ev;
    },
    clickEliminaQuestionarioAllegato(arg) {
      this.id_questionario_sel = arg.id_relazione;
      this.conferma_eliminazione_questionario = true;
    },
    eliminaQuestionarioAllegato() {
      this.items_questionari_associati.forEach((q) => {
        if (q.id_relazione === this.id_questionario_sel) {
          q.validita = 0;
        }
      });

      this.conferma_eliminazione_questionario = false;
    },
    updatePersonale(ev) {
      this.articolo_ciclo_fasi_personale = ev;
    },
    delFornitura(ev) {
      this.deletedFornitura = ev;
    },
    delMacchina(ev) {
      this.deletedMacchina = ev;
    },
    updateMacchina(ev) {
      this.articolo_ciclo_fasi_macchina = ev;
    },
    updateFornitura(ev) {
      ev.map((e) => {
        if (e.id_ciclostd_fasi_fornitori) {
          delete e.id_ciclostd_fasi_fornitori;
        }
      });
      this.fornitoriLista = ev;
    },
    // In order to open allegati dialog
    clickAllegati(item) {
      this.id_fase_sel = item.id_ciclo_fasi;
      this.allegati_dialog_visible = true;
    },
    // Close Allegatio dialog
    chiudiDialogAllegati() {
      this.allegati_dialog_visible = false;
    },
    // Open Ciclo Std Confirmation Dialog
    openconfimationCicloStd(item) {
      this.dailogciclostandardconfirm = true;
      this.selectedCicloStd = item;
    },
    // Add Ciclo Std to existing Ciclo
    setAsChild() {
      let getCicloStd = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getciclostd",
          token: localStorage.getItem("user_token"),
          id_ciclostd: this.selectedCicloStd.id_ciclostd,
          id_articolo: "",
          tipo_import: "",
        },
      };
      this.$store.dispatch("api", getCicloStd).then((res) => {
        let data = res.data.ciclostd[0].ciclostd_dettaglio;
        this.selected = data;
        this.showFasi();
        this.dailogciclostandardconfirm = false;
        this.dialogciclistandard = false;
      });
    },
    // To set Ciclo Std as New ciclo or replace with existing ciclo
    setAsCicloNew() {
      this.overlay = true;
      for (let index = 0; index < this.cicloLista.length; index++) {
        const element = this.cicloLista[index];
        element.validita = 0;
        let delCiclo = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setciclodettaglio",
            token: localStorage.getItem("user_token"),
            articolo_ciclo_dettaglio: [element],
          },
        };
        this.$store
          .dispatch("api", delCiclo)
          .then(() => {
            this.overlay = false;
            let i = this.cicloLista.findIndex(
              (it) => it.id_ciclo_fasi === element.id_ciclo_fasi
            );
            this.cicloLista.splice(i, 1);
          })
          .catch((err) => {
            console.error(err);
            this.overlay = false;
          });
      }
      let getCicloStd = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getciclostd",
          token: localStorage.getItem("user_token"),
          id_ciclostd: this.selectedCicloStd.id_ciclostd,
          id_articolo: "",
          tipo_import: "",
        },
      };
      this.$store.dispatch("api", getCicloStd).then((res) => {
        this.selected = res.data.ciclostd[0].ciclostd_dettaglio;
        this.showFasi();
        this.dailogciclostandardconfirm = false;
        this.dialogciclistandard = false;
      });
    },
    snackbarOpen() {
      //funzione triggerata per cogliere l' errore degli allegati che non hanno la descrizione inserita
      this.snackbar = true;
      this.snackbar_background = "orange";
      this.snackbar_icon = "mdi-alert";
      this.snackbar_icon_color = "white";
      this.snackbar_text =
        "Aggiungere ad ogni Allegato dell'attività una descrizione.";
      this.snackbar_text_color = "white";
    },
    salvaAllegati() {
      if (this.$refs.componenteAllegati != undefined) {
        if (!this.$refs.componenteAllegati.allegato_sel.des_allegato) {
          this.snackbar = true;
          this.color = "orange";
          this.snackbar_icon = "mdi-alert";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "È necessario des di allegato.";
          this.snackbar_text_color = "white";
          return;
        }
      }
      this.$refs.componenteAllegati.id_riferimento_creazione_genitore =
        this.id_fase_sel;
      this.$refs.componenteAllegati.salvaTuttiAllegati();
      this.allegati_dialog_visible = false;
    },
    // Show All Ciclo Standard
    getCicloStd() {
      let getCicolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getciclostd",
          token: localStorage.getItem("user_token"),
          id_ciclostd: "",
          id_articolo: "",
          tipo_import: "",
        },
      };
      this.$store.dispatch("api", getCicolo).then((res) => {
        const data = res.data.lista;
        this.cicloheaders = res.data.header;
        let data2 = {
          value: "edit",
          sortable: false,
        };
        this.cicloheaders.unshift(data2);
        let data1 = {
          value: "delete",
          sortable: false,
        };
        this.cicloheaders.push(data1);
        this.cicloitems = data;
        this.overlay = false;
        this.dialogciclistandard = true;
      });
    },
    //Show Fasi is to add fasi standard to Table directly from the page
    showFasi() {
      this.overlay = true;
      for (let index = 0; index < this.selected.length; index++) {
        let it = this.selected[index];
        let getArticoloStandardDettaglioFromFaseStandard = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getfasestd",
            token: localStorage.getItem("user_token"),
            id_ciclostd_dettaglio: it.id_ciclostd_dettaglio,
            id_articolo:
              this.is_selezione_multipla === true ? -1 : this.id_articolo,
            tipo_import: "A",
          },
        };
        this.$store
          .dispatch("api", getArticoloStandardDettaglioFromFaseStandard)
          .then((res) => {
            this.overlay = false;
            this.FaseStandDetail = res.data.articolo_ciclo_dettaglio[0];
            const i = this.cicloLista.find(
              (it) => it.cod_fase == this.FaseStandDetail.cod_fase
            );
            if (i) {
              this.last_item = this.cicloLista[this.cicloLista.length - 1];
              this.FaseStandDetail.cod_fase =
                parseInt(this.last_item.cod_fase) + 10;

              // Se sono nella selezione multipla di EM mi metto la fase standard in tasca.
              if (this.is_selezione_multipla === true) {
                this.FaseStandDetail.id_ciclo_fasi = moment().valueOf();
                this.cicloLista.push(_.cloneDeep(this.FaseStandDetail));
                this.cicloLista.sort(
                  (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
                );
                this.last_item = null;
              } else {
                // Se invece non sono nella selezione multipla di EM faccio una chiamata BE.
                let updateCiclo = {
                  controller: "Magazzino",
                  method: "PUT",
                  richiesta: {
                    action: "setciclodettaglio",
                    token: localStorage.getItem("user_token"),
                    id_ciclo_fasi: -1,
                    articolo_ciclo_dettaglio: [this.FaseStandDetail],
                  },
                };

                this.overlay = true;
                this.$store.dispatch("api", updateCiclo).then((res) => {
                  if (res.status == 200) {
                    this.overlay = false;
                    this.getCicli();
                    this.cicloLista.sort(
                      (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
                    );
                    this.last_item = null;
                  }
                });
              }
            } else {
              // Se sono nella selezione multipla di EM mi metto la fase standard in tasca.
              if (this.is_selezione_multipla === true) {
                this.cicloLista.push(_.cloneDeep(this.FaseStandDetail));
                this.cicloLista.sort(
                  (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
                );
                this.last_item = null;
              } else {
                // Se invece non sono nella selezione multipla di EM faccio una chiamata BE.
                let updateCiclo = {
                  controller: "Magazzino",
                  method: "PUT",
                  richiesta: {
                    action: "setciclodettaglio",
                    token: localStorage.getItem("user_token"),
                    id_ciclo_fasi: -1,
                    articolo_ciclo_dettaglio: [this.FaseStandDetail],
                  },
                };

                this.overlay = true;
                this.$store.dispatch("api", updateCiclo).then((res) => {
                  this.overlay = false;
                  this.FaseStandDetail.id_ciclo_fasi =
                    res.data[0].id_ciclo_fasi;
                  this.getCicli();
                  this.cicloLista.sort(
                    (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
                  );
                });
              }
            }
          })
          .catch((err) => {
            this.overlay = false;
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile salvare i dati"
            );
          });
      }

      this.dialogfasestandard = false;
      this.selected = [];
    },
    // To get the list of Fase Standard
    getFaseStd() {
      this.overlay = true;
      let getCicolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getfasestd",
          token: localStorage.getItem("user_token"),
          id_ciclostd_dettaglio: "",
        },
      };
      this.$store
        .dispatch("api", getCicolo)
        .then((res) => {
          this.overlay = false;
          const data = res.data.lista;
          this.fasiHeaders = res.data.header;
          let data2 = {
            value: "edit",
            sortable: false,
          };
          this.fasiHeaders.unshift(data2);
          let data1 = {
            value: "delete",
            sortable: false,
          };
          this.fasiHeaders.push(data1);
          data.sort((a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase));
          this.fasiStdLista = data;
          if (this.cicloLista.length > 0) {
            this.progressBarCiclo = false;
            this.loadingCiclo = false;
          }
          if (this.cicloLista.length === 0) {
            this.progressBarCiclo = false;
            this.loadingCiclo = false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati"
          );
        });
    },
    // In order to Add Fase Standard into Ciclo table
    addToCicli(item) {
      this.overlay = true;
      let getFaseStandardDettaglio = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getfasestd",
          token: localStorage.getItem("user_token"),
          id_ciclostd_dettaglio: item.id_ciclostd_dettaglio,
          id_articolo:
            this.is_selezione_multipla === true ? -1 : this.id_articolo,
          tipo_import: "A",
        },
      };
      this.$store
        .dispatch("api", getFaseStandardDettaglio)
        .then((res) => {
          this.overlay = false;
          this.singleitem = res.data.articolo_ciclo_dettaglio[0];
          this.fornitoriLista = this.singleitem.articolo_ciclo_fasi_fornitori;
          this.articolo_ciclo_fasi_macchina =
            this.singleitem.articolo_ciclo_fasi_macchina;
          this.articolo_ciclo_fasi_personale =
            this.singleitem.articolo_ciclo_fasi_personale;
          this.ID_CICLO_FASI = this.singleitem.ID_CICLO_FASI;
          this.ID_ARTICOLO = this.singleitem.ID_ARTICOLO;
          this.cod_fase = this.singleitem.cod_fase;
          this.percentuale_parallelismo =
            this.singleitem.percentuale_parallelismo;
          this.pezzi_setup = this.singleitem.pezzi_setup;
          this.pezzi_parallelismo = this.singleitem.pezzi_parallelismo;
          this.des1 = this.singleitem.des1;
          this.des = this.singleitem.des;
          this.materia_prima = this.singleitem.materia_prima;
          this.tempo_standard = this.singleitem.tempo_standard;
          this.peso = this.singleitem.peso;
          this.fase_esterna = this.singleitem.fase_esterna;
          this.id_ciclo_fasi = this.singleitem.id_ciclo_fasi;
          this.note = this.singleitem.note;
          this.id_um_pezzo = this.singleitem.id_um_pezzo;
          this.id_um_tempo = this.singleitem.id_um_tempo;
          this.um_tempo = this.singleitem.um_tempo;
          this.um_pezzo = this.singleitem.um_pezzo;
          this.articolo_ciclo_fasi_macchina.sort((a, b) => {
            if (a.des_macchina < b.des_macchina) {
              return -1;
            }
            if (a.des_macchina > b.des_macchina) {
              return 1;
            }
            return 0;
          });
          this.articolo_ciclo_fasi_personale.sort((a, b) => {
            if (a.competenza < b.competenza) {
              return -1;
            }
            if (a.competenza > b.competenza) {
              return 1;
            }
            return 0;
          });
          if (this.articolo_ciclo_fasi_personale.length > 0) {
            this.progressBarPersonale = false;
            this.loadingPersonale = false;
          }
          if (this.articolo_ciclo_fasi_personale.length === 0) {
            this.progressBarPersonale = false;
            this.loadingPersonale = false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati"
          );
        });
      this.dialogfasestandard1 = false;
    },
    // In order to check two Cod_fase with same value\
    checkcodfase() {
      if (this.cicloLista.length === 0) {
        this.dialogSavingConfirmation = true;
      }
      this.cicloLista.map((it) => {
        if (it.cod_fase == this.cod_fase && this.id_ciclo_fasi === "") {
          this.snackbar = true;
          this.mainIcon = "mdi-alert";
          this.color = "yellow accent-4";
          this.snackbar_text =
            "Non è possibile salvare due cicli con lo stesso codice fase.";
          this.dialogSavingConfirmation = false;
          return;
        }
        if (
          it.cod_fase == this.cod_fase &&
          this.id_ciclo_fasi != it.id_ciclo_fasi
        ) {
          this.snackbar = true;
          this.mainIcon = "mdi-alert";
          this.color = "yellow accent-4";
          this.snackbar_text =
            "Non è possibile salvare due cicli con lo stesso codice fase.";
          this.dialogSavingConfirmation = false;
          return;
        } else {
          if (!this.snackbar) {
            this.dialogSavingConfirmation = true;
          }
        }
      });
    },

    handleQuestionarioSelezionato(arg) {
      const obj_tmp = {
        id_relazione: -1,
        id_riferimento: this.id_fase_sel,
        id_modulo: arg.id_questionario,
        riferimento: "articolo_ciclo_fasi",
        pk_riferimento: "id_ciclo_fasi",
        modulo: "questionario",
        pk_modulo: "id_questionario",
        validita: 1,
      };

      const request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "updaterelazioni",
          token: localStorage.user_token,
          tabella: [obj_tmp],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getRelazioniModuli();
            this.check_dialog_visible = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile cancellare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile cancellare i dati."
          );
        });
    },
    // In order to Open Deletion Pop up
    seletedCiclo(item) {
      this.selectedCiclo = item;
      this.dialogdeletecicloconfirmation = true;
    },
    // TO Deselect the item when hit Annulla of deletion
    delSelectedItem() {
      this.dialogdeletecicloconfirmation = false;
      this.selectedCiclo = {};
    },
    // In order to update Fase Lista
    aggiornaFase() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "FASE",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.fase_list = res.data;
        this.fase_list.map((el) => {
          this.fase_lavorazione_list.push(el.des);
        });
      });
    },
    // In order to open Ciclo form dialog
    opendialogciclo() {
      this.des1 = "";
      this.materia_prima = 0;
      this.tempo_standard = "";
      this.fase_esterna = 0;
      this.singleitem = {};
      this.ID_ARTICOLO = -1;
      this.ID_CICLO_FASI = -1;
      this.des = "";
      this.cod_fase = "";
      this.percentuale_parallelismo = 0;
      this.pezzi_setup = 0;
      this.pezzi_parallelismo = 0;
      this.dialogCiclo = true;
      this.id_ciclo_fasi = "";
      this.um_tempo = "";
      this.um_pezzo = "";
      this.peso = "";
      this.note = "";
      this.$nextTick(() => {
        this.$refs.Macchinedetails.articolo_ciclo_fasi_macchina = [];
        this.$refs.Personaledetails.articolociclipersonale = [];
        this.$refs.Fornitoridetails.fornitoriLista = [];
      });
      this.dataToUpdate = {};
    },
    // In order to clear the personale form when simply closing it
    closeDialog() {
      this.dialogCiclo = false;
      this.articolo_ciclo_fasi_personale = [];
      this.fornitoriLista = [];
      this.articolo_ciclo_fasi_macchina = [];
      this.codice = "";
      this.des1 = "";
      this.materia_prima = "";
      this.tempo_standard = "";
      this.des = "";
      this.fase_esterna = 0;
    },
    // Getting the single ciclo value
    handleClick(value) {
      this.dialogCiclo = true;
      this.singleitem = value;
      this.cod_fase = this.singleitem.cod_fase;
      this.flag_segnalazione = this.singleitem.flag_segnalazione;
      this.multioperatore = this.singleitem.multioperatore;
      this.lead_time = this.singleitem.lead_time;
      this.percentuale_parallelismo = this.singleitem.percentuale_parallelismo;
      this.pezzi_setup = this.singleitem.pezzi_setup;
      this.pezzi_parallelismo = this.singleitem.pezzi_parallelismo;
      this.des1 = this.singleitem.des1;
      this.des = this.singleitem.des;
      this.materia_prima = this.singleitem.materia_prima;
      this.tempo_standard = this.singleitem.tempo_standard;
      this.peso = this.singleitem.peso;
      this.fase_esterna = this.singleitem.fase_esterna;
      this.id_ciclo_fasi = this.singleitem.id_ciclo_fasi;
      this.note = this.singleitem.note;
      this.id_um_pezzo = this.singleitem.id_um_pezzo;
      this.id_um_tempo = this.singleitem.id_um_tempo;
      this.um_tempo = this.singleitem.um_tempo;
      this.um_pezzo = this.singleitem.um_pezzo;
      this.progressBarMacchina = true;
      this.loadingMacchina = true;

      /* Se sono sulla Selezione Multipla di EM, cerco
       * nell'oggetto cliccato i valori per le tabelle
       * del personale, delle macchine e dei fornitori.
       * Alrimenti i dati arrivano automaticamente dal BE. */
      if (this.is_selezione_multipla === true) {
        this.articolo_ciclo_fasi_macchina = _.cloneDeep(
          value.articolo_ciclo_fasi_macchina
        );
        this.articolo_ciclo_fasi_personale = _.cloneDeep(
          value.articolo_ciclo_fasi_personale
        );
        this.fornitoriLista = _.cloneDeep(value.articolo_ciclo_fasi_fornitori);
      }

      // Getting the single ciclo value
      this.loadingFornitura = true;
      this.progressBarFornitura = true;
      // IN order to get Ciclo fornitori list List to p
      this.ID_CICLO_FASI = this.singleitem.id_ciclo_fasi;
    },
    // In order to remove ciclo
    delCiclo() {
      let data = this.selectedCiclo;
      data.validita = 0;
      let delCiclo = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setciclodettaglio",
          token: localStorage.getItem("user_token"),
          articolo_ciclo_dettaglio: [data],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", delCiclo)
        .then(() => {
          this.snackbar = true;
          this.overlay = false;
          this.snackbar_text = "Modifica effettuata con successo!";
          this.color = "green darken-3";
          this.mainIcon = "mdi-check-circle";
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile salvare i dati"
          );
        });

      let i = this.cicloLista.findIndex(
        (it) => it.id_ciclo_fasi === data.id_ciclo_fasi
      );
      this.cicloLista.splice(i, 1);
      this.dialogdeletecicloconfirmation = false;
    },
    switchFlagMultioperatore() {
      this.multioperatore =
        this.multioperatore == null ||
        this.multioperatore == "" ||
        this.multioperatore == 0
          ? 1
          : 0;
    },
    switchFlagSegnalazione() {
      this.flag_segnalazione =
        this.flag_segnalazione == null ||
        this.flag_segnalazione == "" ||
        this.flag_segnalazione == 0
          ? 1
          : 0;
    },
    // In order to save a new ciclo or update an existing one
    UpdateCicloFasi() {
      // Controllo che il tipo e la fase siano valorizzati.
      if (this.des1 == "" || this.des == "") {
        this.snackbar = true;
        this.mainIcon = "mdi-alert";
        this.color = "yellow accent-4";
        this.snackbar_text =
          "Definire almeno il Tipo Produzione e la Fase Lavorazione per salvare.";
        return;
      }

      // Se la fase da salvare è nuova...
      if (this.id_ciclo_fasi === "" || this.id_ciclo_fasi == -1) {
        // Controllo che sia presente il codice fase.
        if (this.cod_fase === "") {
          this.snackbar = true;
          this.mainIcon = "mdi-alert";
          this.color = "yellow accent-4";
          this.snackbar_text = "Inserire il Cod Fase prima di salvare.";
          return;
        }
        let data = {};
        this.produzione_list.map((el) => {
          if (el.des === this.des1) {
            data.id_tipo_fase = el.id_tabella;
            return data;
          }
        });
        this.fase_list.map((el) => {
          if (el.des === this.des) {
            data.id_fase = el.id_tabella;
            return data;
          }
        });
        data.flag_segnalazione = this.flag_segnalazione;
        data.multioperatore = this.multioperatore;
        data.lead_time = this.lead_time;
        data.peso = this.peso;
        data.id_ciclo_fasi = -1;
        data.cod_fase = this.cod_fase;
        data.percentuale_parallelismo = this.percentuale_parallelismo;
        data.pezzi_setup = this.pezzi_setup;
        data.pezzi_parallelismo = this.pezzi_parallelismo;
        data.note = this.note;
        data.des = this.des;
        data.des1 = this.des1;
        data.cod_macchina = this.cod_macchina;
        data.costo_lavorazione = this.costo_lavorazione;
        data.id_articolo = this.id_articolo;
        data.fase_esterna = this.fase_esterna;
        data.materia_prima = this.materia_prima;
        data.tempo_standard = this.tempo_standard;
        data.id_um_tempo = this.um_tempo;
        this.unita_misura_lead_time.map((ui) => {
          if (ui.des === data.id_um_tempo) {
            data.id_um_tempo = ui.id_tabella;
            data.um_tempo = ui.des;
          }
        });
        data.id_um_pezzo = this.um_pezzo;
        this.unita_misura_peso.map((ui) => {
          if (ui.des === data.id_um_pezzo) {
            data.id_um_pezzo = ui.id_tabella;
            data.um_pezzo = ui.des;
          }
        });
        data.validita = 1;
        data.articolo_ciclo_fasi_personale = this.articolo_ciclo_fasi_personale;
        data.articolo_ciclo_fasi_macchina = this.articolo_ciclo_fasi_macchina;
        data.articolo_ciclo_fasi_fornitori = this.fornitoriLista;
        this.fase_list.map((fa) => {
          if (fa.des === data.des) {
            data.id_fase = fa.id_tabella;
          }
          this.produzione_list.map((prod) => {
            if (prod.des === data.des1) {
              data.id_tipo_fase = prod.id_tabella;
            }
          });
        });
        if (this.fase_esterna) {
          var fornitoriwithpref = [];
          data.articolo_ciclo_fasi_fornitori.map((it) => {
            if (it.predefinito !== 0) {
              fornitoriwithpref.push(it);
            }
          });
          if (fornitoriwithpref.length < 1) {
            this.snackbar = true;
            this.mainIcon = "mdi-alert";
            this.color = "yellow accent-4";
            this.snackbar_text =
              "È necessario selezionare una fornitura predefinita.";
            return;
          }
          data.articolo_ciclo_fasi_macchina.map((it) => (it.predefinito = 0));
        }

        if (!this.fase_esterna) {
          var macchinawithpref = [];
          data.articolo_ciclo_fasi_macchina.map((it) => {
            if (it.predefinito == 1 && it.validita == 1) {
              macchinawithpref.push(it);
            }
          });

          /* Controllo che nelle fasi interne di tipo
           * "produzione" sia indicata una macchina predefinita. */
          /* Controllo su fasi interne di non produzione disabilitato
           * il 21/09/2023 su richiesta di ALberto per Ferrara Quarzi. */
          if (
            macchinawithpref.length < 1 /*&&
            this.produzione_list.filter((e) => e.des == this.des1)[0].cod ===
              "P"*/
          ) {
            this.snackbar = true;
            this.mainIcon = "mdi-alert";
            this.color = "yellow accent-4";
            this.snackbar_text =
              "Le fasi interne devono essere associate a una macchina predefinita.";
            return;
          }
          data.articolo_ciclo_fasi_fornitori.map((it) => (it.predefinito = 0));
        }
        let dataArray = [];
        dataArray.push(data);

        if (this.is_selezione_multipla === true) {
          this.snackbar = true;
          this.snackbar_text = "Modifica effettuata con successo!";
          this.color = "green darken-3";
          this.mainIcon = "mdi-check-circle";
          data.id_ciclo_fasi = moment().valueOf();
          this.cicloLista.push(data);
          this.cicloLista.sort(
            (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
          );
        }

        if (this.is_selezione_multipla === false) {
          let updateCiclo = {
            controller: "Magazzino",
            method: "PUT",
            richiesta: {
              action: "setciclodettaglio",
              token: localStorage.getItem("user_token"),
              id_ciclo_fasi: -1,
              articolo_ciclo_dettaglio: dataArray,
            },
          };

          this.overlay = true;
          this.$store
            .dispatch("api", updateCiclo)
            .then((res) => {
              this.overlay = false;
              if (res.status === 200) {
                this.getCicli();
              }
              this.snackbar = true;
              this.snackbar_text = "Modifica effettuata con successo!";
              this.color = "green darken-3";
              this.mainIcon = "mdi-check-circle";
              data.id_ciclo_fasi = res.data[0].id_ciclo_fasi;
              this.cicloLista.push(data);
              this.cicloLista.sort(
                (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
              );
            })
            .catch((err) => {
              this.overlay = false;
              console.error(err);
              this.$refs.SnackbarQV.print(
                "error",
                "Errore di comunicazione col server, impossibile salvare i dati"
              );
            });
        }
        this.dialogCiclo = false;
        this.codice = "";
        this.peso = "";
        this.des = "";
        this.des1 = "";
        this.materia_prima = "";
        this.tempo_standard = "";
        this.peso = "";
        this.fase_esterna = "";
        this.note = "";
        this.id_ciclo_fasi = "";
        this.cod_fase = "";
        this.percentuale_parallelismo = 0;
        this.pezzi_setup = 0;
        this.pezzi_parallelismo = 0;
        this.dialogSavingConfirmation = false;
        this.overlay = false;
      } else {
        // Se invece la fase da salvare non è nuova...

        // Controllo che il cod. fase sia valorizzato
        if (this.cod_fase === "") {
          this.snackbar = true;
          this.mainIcon = "mdi-alert";
          this.color = "yellow accent-4";
          this.snackbar_text = "Inserire il Cod Fase prima di salvare.";
          return;
        }

        let data = this.singleitem;

        this.produzione_list.map((el) => {
          if (el.des === this.des1) {
            data.id_tipo_fase = el.id_tabella;
            return data;
          }
        });

        this.fase_list.map((el) => {
          if (el.des === this.des) {
            data.id_fase = el.id_tabella;
            return data;
          }
        });

        data.cod_macchina = this.singleitem.cod_macchina;
        data.cod_fase = this.cod_fase;
        data.percentuale_parallelismo = this.percentuale_parallelismo;
        data.pezzi_setup = this.pezzi_setup;
        data.pezzi_parallelismo = this.pezzi_parallelismo;
        data.costo_lavorazione = this.singleitem.costo_lavorazione;
        data.date_ins = this.singleitem.date_ins;
        data.date_mod = this.singleitem.date_mod;
        data.flag_segnalazione = this.flag_segnalazione;
        data.multioperatore = this.multioperatore;
        data.lead_time = this.lead_time;
        data.des = this.des;
        data.des1 = this.des1;
        data.fase_esterna = this.fase_esterna;
        data.materia_prima = this.materia_prima;
        data.id_anagrafica = this.singleitem.id_anagrafica;
        data.id_articolo = this.singleitem.id_articolo;
        data.id_attrezzatura = this.singleitem.id_attrezzatura;
        data.id_ciclo_fasi = this.singleitem.id_ciclo_fasi;
        data.id_ciclo_testa = this.singleitem.id_ciclo_testa;
        data.id_fase = this.id_fase;
        data.id_macchina = this.singleitem.id_macchina;
        data.id_tipo_fase = this.id_tipo_fase;
        data.id_utente = localStorage.id;
        data.lead_time = this.singleitem.lead_time;
        data.lotto_lavorazione = this.singleitem.lotto_lavorazione;
        data.lotto_produzione = this.singleitem.lotto_produzione;
        data.materia_prima = this.singleitem.materia_prima;
        data.note = this.note;
        data.peso = this.peso;
        data.pezzi_ora_max = this.singleitem.pezzi_ora_max;
        data.pezzi_ora_min = this.singleitem.pezzi_ora_min;
        data.ragione_sociale = this.singleitem.ragione_sociale;
        data.riga = this.singleitem.riga;
        data.riga_fase = this.singleitem.riga_fase;
        data.tempo_setup = this.singleitem.tempo_setup;
        data.tempo_standard = this.tempo_standard;
        data.validita = this.singleitem.validita;
        data.id_um_tempo = this.um_tempo;
        data.id_um_pezzo = this.um_pezzo;
        this.fase_list.map((fa) => {
          if (fa.des === data.des) {
            data.id_fase = fa.id_tabella;
          }
          this.produzione_list.map((prod) => {
            if (prod.des === data.des1) {
              data.id_tipo_fase = prod.id_tabella;
            }
          });
        });
        this.unita_misura_lead_time.map((ui) => {
          if (ui.des === data.id_um_tempo) {
            data.id_um_tempo = ui.id_tabella;
            data.um_tempo = ui.des;
          }
        });
        this.unita_misura_peso.map((ui) => {
          if (ui.des === data.id_um_pezzo) {
            data.id_um_pezzo = ui.id_tabella;
            data.um_pezzo = ui.des;
          }
        });
        if (this.deletedMacchina.length > 0) {
          this.deletedMacchina.map((el) => {
            this.articolo_ciclo_fasi_macchina.push(el);
          });
        }
        if (this.deletedPersonale.length > 0) {
          this.deletedPersonale.map((el) => {
            this.articolo_ciclo_fasi_personale.push(el);
          });
        }
        if (this.deletedFornitura.length > 0) {
          this.deletedFornitura.map((el) => {
            this.fornitoriLista.push(el);
          });
        }
        data.articolo_ciclo_fasi_personale = this.articolo_ciclo_fasi_personale;
        data.articolo_ciclo_fasi_macchina = this.articolo_ciclo_fasi_macchina;
        data.articolo_ciclo_fasi_fornitori = this.fornitoriLista;
        if (this.fase_esterna) {
          let fornitoriwithpref = [];
          data.articolo_ciclo_fasi_fornitori.map((it) => {
            if (it.predefinito !== 0) {
              fornitoriwithpref.push(it);
            }
          });
          if (fornitoriwithpref.length < 1) {
            this.snackbar = true;
            this.mainIcon = "mdi-alert";
            this.color = "yellow accent-4";
            this.snackbar_text =
              "È necessario selezionare una fornitura predefinita.";
            return;
          }
          data.articolo_ciclo_fasi_macchina.map((it) => (it.predefinito = 0));
        }
        if (!this.fase_esterna) {
          let macchinawithpref = [];
          data.articolo_ciclo_fasi_macchina.map((it) => {
            if (it.predefinito == 1 && it.validita == 1) {
              macchinawithpref.push(it);
            }
          });

          /* Controllo su fasi interne di non produzione disabilitato
           * il 21/09/2023 su richiesta di ALberto per Ferrara Quarzi. */
          if (
            macchinawithpref.length < 1 /*&&
            this.produzione_list.filter((e) => e.des == this.des1)[0].cod ===
              "P"*/
          ) {
            this.snackbar = true;
            this.mainIcon = "mdi-alert";
            this.color = "yellow accent-4";
            this.snackbar_text =
              "Le fasi interne devono essere associate a una macchina predefinita.";
            return;
          }
          data.articolo_ciclo_fasi_fornitori.map((it) => (it.predefinito = 0));
        }
        let dataArray = [];
        dataArray.push(data);

        /* Se sono nel componente di selezione multipla di EM
         * non salvo e non carico un caspita, e mi tengo le modifiche
         * in tasca perché salverò eventualmente tutto dopo. */
        if (this.is_selezione_multipla === true) {
          // Stampo una snackbar di conferma.
          this.snackbar = true;
          this.snackbar_text = "Modifica effettuata con successo!";
          this.color = "green darken-3";
          this.mainIcon = "mdi-check-circle";

          // Applico le modifiche sulla tabella principale.
          for (let i = 0; i < this.cicloLista.length; i++) {
            if (this.cicloLista[i].id_ciclo_fasi === data.id_ciclostd_fasi) {
              this.$set(this.cicloLista, i, _.cloneDeep(data));
            }
          }

          // Riordino la lista, caso mai servisse.
          this.cicloLista.sort(
            (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
          );
        }

        /* Se invece sono sui componenti standard di
         *  QuickProduction, salvo effettivamente il dato. */
        if (this.is_selezione_multipla === false) {
          let updateCiclo = {
            controller: "Magazzino",
            method: "PUT",
            richiesta: {
              action: "setciclodettaglio",
              token: localStorage.getItem("user_token"),
              id_ciclo_fasi: this.singleitem.id_ciclo_fasi,
              articolo_ciclo_dettaglio: dataArray,
            },
          };

          this.overlay = true;
          this.$store.dispatch("api", updateCiclo).then((res) => {
            this.overlay = false;
            if (res.status === 200) {
              this.getCicli();
            }
            this.snackbar = true;
            this.snackbar_text = "Modifica effettuata con successo!";
            this.color = "green darken-3";
            this.mainIcon = "mdi-check-circle";
          });
        }
        this.dialogCiclo = false;
        data = {};
        this.codice = "";
        this.peso = "";
        this.des = "";
        this.des1 = "";
        this.materia_prima = "";
        this.tempo_standard = "";
        this.peso = "";
        this.fase_esterna = "";
        this.note = "";
        this.id_ciclo_fasi = "";
        this.id_ciclo_test = "";
        this.singleitem = {};
        this.cod_fase = "";
        this.percentuale_parallelismo = 0;
        this.pezzi_setup = 0;
        this.pezzi_parallelismo = 0;
        this.id_ciclo_fasi = "";
        this.dialogSavingConfirmation = false;
        this.overlay = false;
      }
    },
    getCicli() {
      this.cicloLista = [];
      // Getting Ciclo lista to populate the table
      let getCicolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoliciclo",
          token: localStorage.getItem("user_token"),
          id_articolo: this.id_articolo,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", getCicolo)
        .then((res) => {
          this.overlay = false;
          const data = res.data;
          this.ID_ARTICOLO = -1;
          this.ID_CICLO_FASI = -1;
          data.sort((a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase));
          this.cicloLista = data;
          if (this.cicloLista.length > 0) {
            this.progressBarCiclo = false;
            this.loadingCiclo = false;
          }
          if (this.cicloLista.length === 0) {
            this.progressBarCiclo = false;
            this.loadingCiclo = false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati"
          );
        });
    },
    getPulsantiQuestionari() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          id_profilo: "",
          tipo_oggetto: "B",
          nome_modulo: "AVANZAMENTO",
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Resetto l'array dei pulsanti.
            this.items_pulsanti_questionari = new Array();
            const arr_tmp = new Array();
            // Popolo l'array dei pulsanti.
            res.data.forEach((e) => {
              if (e.tipo_oggetto === "B") {
                arr_tmp.push({
                  id_header: e.id_header,
                  value: e.fields,
                  text: "(B) " + e.text,
                });
              } else if (e.tipo_oggetto === "E") {
                arr_tmp.push({
                  id_header: e.id_header,
                  value: e.fields,
                  text: "(E) " + e.text,
                });
              }
            });

            arr_tmp.sort(function (a, b) {
              return ("" + a.text).localeCompare(b.text);
            });
            this.items_pulsanti_questionari = JSON.parse(
              JSON.stringify(arr_tmp)
            );
          } else {
            this.$rfs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$rfs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    salvaCicloMultiplo() {
      /* Genero gli array degli identificativi
       * e degli oggetti del ciclo. */
      const arr_id = new Array();
      const arr_obj = _.cloneDeep(this.cicloLista);

      // Popolo l'array degli identificativi.
      this.id_articoli_sel.forEach((e) => {
        arr_id.push(e.id_articolo);
      });

      // Modello gli oggetti del ciclo per convenienza di BE
      let id_tmp = -1;
      arr_obj.forEach((e) => {
        e.id_temp = id_tmp;
        e.id_ciclo_fasi = id_tmp;

        e.articolo_ciclo_fasi_fornitori.forEach((f) => {
          f.id_temp = e.id_ciclo_fasi;
        });
        e.articolo_ciclo_fasi_macchina.forEach((m) => {
          m.id_temp = e.id_ciclo_fasi;
        });
        e.articolo_ciclo_fasi_personale.forEach((p) => {
          p.id_temp = e.id_ciclo_fasi;
        });

        id_tmp -= 1;
      });

      if (arr_id.length == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare almeno un articolo."
        );
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "updatearticolociclofasi",
          token: localStorage.user_token,
          id: arr_id,
          ciclo: arr_obj,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Fasi aggiornate con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    salvaQuestionariAssociati() {
      // Controllo che gli eventi siano ok.
      let chk_btn = true;

      this.items_questionari_associati
        .filter((e) => e.validita == 1)
        .forEach((f1) => {
          if (f1.pulsante == null || f1.pulsante == "") {
            chk_btn = false;
          }
        });

      if (chk_btn === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Tutti i questionari devono essere associati ai pulsanti."
        );
        return;
      }

      const arr_tmp = JSON.parse(
        JSON.stringify(this.items_questionari_associati)
      );

      /* Se l'id_padre è nullo la chiamata andrà in
       * errore, quindi elimino gli id_padre nulli. */
      arr_tmp.forEach((elem) => {
        if (elem.id_padre == null) {
          delete elem.id_padre;
        }
      });

      const request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "updaterelazioni",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.questionari_fase_visible = false;
            this.$refs.SnackbarQV.print(
              "success",
              "Relazioni aggiornate con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    switchMultiplo(arg) {
      // Mi faccio un oggetto con il valore di selezione corretto.
      const obj_tmp = Object.assign({}, arg);
      obj_tmp.multiplo = arg.multiplo == 0 ? 1 : 0;

      // Mi metto da parte l'indice selezionato.
      let index = -1;
      for (let i = 0; i < this.items_questionari_associati.length; i++) {
        if (
          this.items_questionari_associati[i].id_relazione == arg.id_relazione
        ) {
          index = i;
        }
      }

      this.$set(this.items_questionari_associati, index, obj_tmp);
    },
    switchObblogatorieta(arg) {
      // Mi faccio un oggetto con il valore di selezione corretto.
      const obj_tmp = Object.assign({}, arg);
      obj_tmp.obbligatorio = arg.obbligatorio == 0 ? 1 : 0;

      // Mi metto da parte l'indice selezionato.
      let index = -1;
      for (let i = 0; i < this.items_questionari_associati.length; i++) {
        if (
          this.items_questionari_associati[i].id_relazione == arg.id_relazione
        ) {
          index = i;
        }
      }

      this.$set(this.items_questionari_associati, index, obj_tmp);
    },
  },
  watch: {
    pezzi_min: {
      immediate: true,
      async handler() {
        if (this.$refs.form != undefined) {
          await this.$nextTick();
          this.$refs.form.validate();
        }
      },
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        if (this.allegati_dialog_visible === true) {
          this.allegati_dialog_visible = false;
        }
      }
    });
    this.getCicli();
    this.getPulsantiQuestionari();
    // Getting all the lista value for select fields
    this.progressBarCiclo = true;
    this.loadingCiclo = true;
    let request = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "gettabelle",
        token: localStorage.getItem("user_token"),
        tipo: "'UNITA_MISURA','TIPO_PRODUZIONE','FASE','EVENTI_QUESTIONARI'",
        filter: "validita = 1",
      },
    };
    this.$store.dispatch("api", request).then((res) => {
      // Gestisco l'array PORTO che mi arriva dal BE
      this.modalita_list = res.data.PORTO;
      // Gestisco l'array UNITA_MISURA che mi arriva dal BE
      res.data.UNITA_MISURA.map((el) => {
        if (el.val_txt === "P") {
          this.unita_misura_peso.push(el);
        }
        if (el.val_txt === "H") {
          this.unita_misura_lead_time.push(el);
        }
      });
      this.unita_misura_mod_list = res.data.UNITA_MISURA
        ? res.data.UNITA_MISURA
        : new Array();
      // Gestisco l'array TIPO_PRODUZIONE che mi arriva dal BE
      this.produzione_list = res.data.TIPO_PRODUZIONE
        ? res.data.TIPO_PRODUZIONE
        : new Array();

      // Gestisco l'array FASE che mi arriva dal BE
      this.fase_list = res.data.FASE ? res.data.FASE : new Array();
      this.fase_lavorazione_list = res.data.FASE ? res.data.FASE : new Array();
    });
  },
};
</script>
<style css>
.dialogshadow {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
  overflow-y: hidden !important;
}
</style>
